import gql from 'graphql-tag';

import fileFragment from '~/shared/graphql-queries/files/file-fragment';

export default gql`
  fragment LessonExerciseFragment on LessonExercise {
    _id
    title
    notes
      status
    originalLessonExercise {
      _id
    }
      tags {
          _id
          name
          alias
      }

      matchedTag {
          _id
          name
          alias
      } 
    data {
      course
      courseCategory
      student
      isShared
      isTodo
      standaloneFile
    }
    slides {
      slide
      _id
    }
    files {
      ...FileFragment
    }
    attachments {
      ...FileFragment
    }
    videos {
      ...FileFragment
    }
    image {
      ...FileFragment
    }
    thumbnail {
      ...FileFragment
    }
    filesStatuses {
      status
      _id
    }
  }
  ${fileFragment}
`;
